import BaseModel from './BaseModel';

class EAPP extends BaseModel {}

EAPP.collection = 'EAPPs';

export default EAPP;
